export default __webpack_public_path__ + "static/media/icon_week_red.41fc8c28.svg";